module.exports = __webpack_public_path__ + "img/box_qty_report.dab3b5d5.png";